import React, {useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useTitle} from '../../function';
import {HomeContainer} from '../../styled/HomeStyle';
import {Header} from '../common';
import {useSelector} from "react-redux";
import styled, {useTheme} from "styled-components";
import ServerStatusErrorbox from "../common/Error/StatusError";
import NewSearch from "../common/NewSearch";
import {home_ad_conetne} from "../../ad/bidrich";
import useAdHooks from "../../common/hooks/useAdHooks";
import UseSetCanonical from "../../common/hooks/useSetCanonical";
import HomeNoticeBoard from "./HomeNoticeBoard/HomeNoticeBoard";
import VenatusAd from "../ad/VenatusAd";
import BottomStickAd from "../ad/BottomStickAd";
import RightRailAd from "../ad/RightRailAd";
import LeftRailAd from "../ad/LeftRailAd";
import usePopUpHooks from "../../common/hooks/usePopUpHooks";
import HomeNotice from "./HomeNotice";


const AdSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 970px;
  height: 250px;
`;

const BannerWrapper = styled.div`
  margin: 0 0 60px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
`;

const ColumnBox = styled.div`
  display: flex;
  flex-direction: column;
`;

const Wrapper = styled(ColumnBox)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;

const BoardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 60px;
`;

// const testTierList = ['challenger','grandmaster','master','diamond','emerald','platinum','gold','silver','bronze','iron','unranked'];

const Home = () => {
    UseSetCanonical();

    const {t, i18n} = useTranslation();
    const titleUpdate = useTitle('Loading...');
    const notice = useSelector((state) => state?.imageStore.notice);
    const country = useSelector((state) => state?.imageStore.country);
    // const argumentsInfo = useSelector((state) => state?.imageStore.argumentsInfo);
    useAdHooks(home_ad_conetne);
    const theme = useTheme();
    const currentLang = useSelector((state) => state.translation.lang)

    const [openFeedback, setOpenFeedback] = useState(false);
    setTimeout(() => titleUpdate(t('header.title')), 500);


    // if(true) {
    //     return (
    //         <Wrapper>
    //             {argumentsInfo.map((data) => {
    //                 return (
    //                     <FlexBox>
    //                         <ArgumentImage imgId={data.id} key={data.id} width={48} height={48}/>
    //                     </FlexBox>
    //
    //                 )
    //             })}
    //         </Wrapper>
    //     )
    // }


    const onClickRiotMore = () => {
        if (currentLang === 'KOR') {
            return window.open('https://www.leagueoflegends.com/ko-kr/news/tags/patch-notes/')
        } else if (currentLang === 'ja') {
            return window.open('https://www.leagueoflegends.com/ja-jp/news/tags/patch-notes/')
        }
        return window.open('https://www.leagueoflegends.com/en-us/news/tags/patch-notes/')

    }


    const onClickDeeplolMore = () => {
        if (currentLang === 'KOR') {
            return window.open('https://deeplol-notice.notion.site/2aa360ac56404feba05e3ee4643ef758?v=2b9f8c6b16a4449d91b64c931a676717')
        } else if (currentLang === 'ja') {
            return window.open('https://deeplol-notice.notion.site/13ff4d23843f8059b5faeefef1c5b4dc?v=13ff4d23843f813b87fc000cb7abba28')
        }
        return window.open('https://deeplol-notice.notion.site/22ccbbf31911418f90d1571fd3bfa745?v=e439086776eb4a5ab7a9d3b939c61e4d')
    }


    return (
        <Wrapper country={country}>
            {/*Rich*/}
            <ColumnBox>
                <Header
                    isHome={true}
                    setOpenView={setOpenFeedback}
                    openView={openFeedback}
                />
                <ServerStatusErrorbox/>
            </ColumnBox>
            <HomeContainer>
                <LeftRailAd/>
                <div className="home" id={'home_content_wrapper'}>
                    {/*<div style={{width: '1200px', position: 'relative'}}>*/}
                    {/*    <PopUpController/>*/}
                    {/*</div>*/}
                    <h2>
                        {currentLang === 'KOR' ?
                            // <img src={`${theme.icon.path}/sll_banner.png`} alt="DEEPLOL" width={1002} height={257}/>
                            null
                            :
                            <img src={`${theme.icon.path}/Logo_Deeplol_Renew.png`} alt="DEEPLOL" width={320} height={57}/>
                        }
                    </h2>
                    <BannerWrapper>
                        <HomeNotice/>
                        <NewSearch home/>
                    </BannerWrapper>

                    {/*<HomeVideoBannerWrapper/>*/}
                    <AdSection class={''} id={'home_content_bottom_ad_box'} data-ad={'billboard'}>
                        <VenatusAd placementName={'billboard'}/>
                    </AdSection>
                    <BoardWrapper>
                        <HomeNoticeBoard title={'RIOT'}
                                         list={notice?.riot_notice_list}
                                         onClickMore={onClickRiotMore}
                        />
                        <HomeNoticeBoard title={'DEEPLOL'}
                                         list={notice?.deeplol_notice_list}
                                         onClickMore={onClickDeeplolMore}
                        />
                    </BoardWrapper>
                </div>
                <RightRailAd/>
            </HomeContainer>
            <BottomStickAd/>

        </Wrapper>
    );
};


const PopUpController = () => {
    const currentLang = useSelector((state) => state.translation.lang);
    const popUpState = useMemo(() => {
        try {
            // const state = localStorage.getItem('popUpState');
            // const numberState = Number(state);
            // if (!state) {
            //     localStorage.setItem('popUpState', "1");
            //     return 1;
            // }
            // if (numberState + 1 > 2) {
            //     localStorage.setItem('popUpState', "1");
            //     return 1;
            // }
            // localStorage.setItem('popUpState', numberState + 1)
            // return numberState + 1
            //
            return 1
        } catch (e) {
            return 0
        }
    }, []);

    const popUpCalc = (time, item) => {
        try {
            if (!time) {
                return true;
            }
            const day = 24 * 60 * 60 * 1000;

            const numberTime = Number(time)
            const nextDay = new Date(Date.now() + day);

            if (numberTime > nextDay.getTime()) {
                localStorage.setItem(item, nextDay.getTime().toString())
            }

            if (numberTime > Date.now()) {
                return false;
            }
            return true
        } catch (e) {
            return true
        }
    }

    const hasDate = useMemo(() => {
        try {
            if (popUpState === 1) {
                return popUpCalc(localStorage.getItem('popup'), 'popup')
            }
            return true
        } catch (e) {
            return true
        }
    }, []);


    if (currentLang !== 'KOR') {
        return null
    }


    if (hasDate && popUpState === 1) {
        return <PopUp/>
    }
    return null

}

const PopUpWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999999;
`;

const PopUpBoxGeneral = styled.div`
  border: 1px solid #787878;
  box-shadow: 2px 2px 4px 0px #00000040;
  color: #354052;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #fff;
  border-radius: 15px;
`;
const PopUpBox = styled(PopUpBoxGeneral)`
  padding-top: 29px;
  padding-bottom: 14px;
  padding-inline: 37px;
`;

const PopUp2Box = styled(PopUpBoxGeneral)`
  padding: 18px 18px 12px;
`;


const PopUpTitle = styled.div`
  text-align: center;
  white-space: pre;
  font-weight: 800;
  font-size: 23px;
  line-height: 125%;
  color: #373737;

`;
const PopUpGradient = styled.div`
  margin-top: 17px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 2px solid transparent;
  background: linear-gradient(white, white) padding-box,
  linear-gradient(103.74deg, #3EF2D9 -3.49%, #4D93FD 75.77%) border-box;
  border-radius: 10px;
  padding: 23px 22.5px;
  box-shadow: 0px 1px 4px 0px #00000040;
`;
const PopUpGradientText = styled.span`
  font-weight: 600;
  font-size: 17px;
  line-height: 125%;
  white-space: pre;
  text-align: center;
`;
const PopUpBlueText = styled.span`
  color: #4BA0F8;
`;

const IconBox = styled.div`
  margin-top: 15px;
`;
const IconItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  img {
    z-index: 2;
  }

  & + & {
    margin-top: 3px;
  }
`;
const GrayBar = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 175%;
  position: absolute;
  display: flex;
  align-items: center;
  background: #EEEEEE;
  padding-left: 20px;
  left: 20px;
  width: 300px;
  height: 21px;
`;
const GrayBarBold = styled.span`
  font-weight: 700;
`;

const DiscordBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 32px;
`;
const DiscordSpan = styled.span`
  white-space: pre;
  margin-bottom: 6px;
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  line-height: 125%;
  color: #5865F2;
`;

const DiscordButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 244px;
  height: 53px;
  background: linear-gradient(110.49deg, #8892FF -27.93%, #5865F2 33.76%, #2739FF 99.95%);
  box-shadow: 0px 2px 2px 0px #00000040;
  border-radius: 15px;
  color: #fff;
  font-size: 19px;
  font-weight: 800;
`;
const DiscordButtonSpan = styled.span`
  margin-left: 5px;
`;


const NotVisible = styled.button`
  margin-top: 13px;
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  color: #979797;
`;

const PopUp = () => {
    const {onClickDisableWeek, ref, visible} = usePopUpHooks({itemName: 'popup'});

    if (!visible) {
        return null
    }
    return (
        <PopUpWrapper ref={ref}>
            <PopUpBox>
                <PopUpTitle>
                    딥롤 커스텀 트래커 {'\n'}
                    Beta 테스트 클랜/스트리머 모집
                </PopUpTitle>
                <PopUpGradient>
                    <PopUpGradientText>
                        딥롤이 새롭게 선보이는{'\n'}
                        <PopUpBlueText>
                            ‘커스텀 트래커’
                        </PopUpBlueText> 기능을 직접 체험해보세요!{'\n'}
                        10인 이상 클랜/모임 또는 스트리머 대상{'\n'}
                        <PopUpBlueText>베타 테스트</PopUpBlueText>를 진행 중입니다.
                    </PopUpGradientText>
                </PopUpGradient>
                <IconBox>
                    <IconItem>
                        <img src={'./images/popup/icon_popup_1.svg'} width={28} height={25} alt={''}/>
                        <GrayBar>
                            <span>내전(사용자 설정 게임) <GrayBarBold>결과</GrayBarBold>가 딥롤에 <GrayBarBold>자동 저장</GrayBarBold></span>
                        </GrayBar>
                    </IconItem>
                    <IconItem>
                        <img src={'./images/popup/icon_popup_2.svg'} width={28} height={25} alt={''}/>
                        <GrayBar>
                            <span>경기 제목 입력으로 손쉽게<GrayBarBold> 경기별 구분</GrayBarBold></span>
                        </GrayBar>
                    </IconItem>
                    <IconItem>
                        <img src={'./images/popup/icon_popup_3.svg'} width={28} height={25} alt={''}/>
                        <GrayBar>
                            <span>AI-Score, 팀 MVP, 등수 등 <GrayBarBold>상세 분석</GrayBarBold> 제공</span>
                        </GrayBar>
                    </IconItem>
                    <IconItem>
                        <img src={'./images/popup/icon_popup_4.svg'} width={28} height={25} alt={''}/>
                        <GrayBar>
                            <span>클라이언트에서 <GrayBarBold>리플레이 재생</GrayBarBold> 가능</span>
                        </GrayBar>
                    </IconItem>
                    <IconItem>
                        <img src={'./images/popup/icon_popup_5.svg'} width={28} height={25} alt={''}/>
                        <GrayBar>
                            <span>디스코드에서 <GrayBarBold>피드백</GrayBarBold> 및 <GrayBarBold>클랜 매칭</GrayBarBold> 지원</span>
                        </GrayBar>
                    </IconItem>
                </IconBox>
                <DiscordBox>
                    <DiscordSpan>
                        10명 이상 구성된 클랜/모임이라면{'\n'}내전을 자주 진행하는 지금, 꼭 참여해보세요!
                    </DiscordSpan>

                    <a href={'https://tally.so/r/nG71ap'} target={'_blank'}>
                        <DiscordButton>
                            <img src={'./images/popup/icon_popup_discord.svg'} width={30} alt={''}/>
                            <DiscordButtonSpan>
                                테스트 클랜 신청하기
                            </DiscordButtonSpan>
                        </DiscordButton>
                    </a>
                    <NotVisible onClick={onClickDisableWeek}>
                        하루 동안 다시 보지 않기
                    </NotVisible>
                </DiscordBox>
            </PopUpBox>
        </PopUpWrapper>
    )
}


export default Home;
